import React from "react";
import { observer } from "mobx-react";
import {
  Switch as SwitchContext,
  Redirect,
  withRouter,
  RouteComponentProps,
} from "react-router-dom";

import AuthStore from "stores/AuthStore";

import Container from "components/Layout/Container";
import Header from "components/Layout/Header";
import PublishButton from "components/PublishButton";

import QuickLinks from "./QuickLinks";
import QuickLinkDetails from "./QuickLinks/QuickLinkDetails";

import { PrivateRoute } from "navigation/Switch";

import ROUTES from "navigation/routes";

type Props = RouteComponentProps & {};

@observer
class ContentResources extends React.Component<Props> {
  render() {
    return (
      <Container header={<Header controls={<PublishButton />} />}>
        <SwitchContext>
          <PrivateRoute
            path={ROUTES.CONTENT_RESOURCES_QUICK_LINKS}
            component={QuickLinks}
            allowAccess={AuthStore.isAuthorized}
            redirectTo={ROUTES.CONTENT_RESOURCES_QUICK_LINKS}
            exact
          />
          <PrivateRoute
            path={ROUTES.CONTENT_RESOURCES_QUICK_LINK_DETAILS}
            component={QuickLinkDetails}
            allowAccess={AuthStore.isAuthorized}
            redirectTo={ROUTES.CONTENT_RESOURCES_QUICK_LINKS}
            exact
          />

          <Redirect to={ROUTES.CONTENT_RESOURCES_QUICK_LINKS} />
        </SwitchContext>
      </Container>
    );
  }
}

export default withRouter(ContentResources);
